/**
 * plan 失败态（plan-page-design ref 02「失败态」、ref 03 §13；PR3 新写，admin 无此组件）：一句原因 + 「重试」（outline）。
 */
import { AlertTriangle } from "lucide-react";

import { Button } from "@/components/ui/button";

export function FailState({
	title = "没加载出来",
	reason,
	onRetry,
	retrying = false,
	testId,
}: {
	title?: string;
	reason: string;
	onRetry?: () => void;
	retrying?: boolean;
	testId?: string;
}) {
	return (
		<div className="flex flex-col items-center gap-1.5 py-10 text-center" data-testid={testId}>
			<AlertTriangle className="h-6 w-6 text-brand-danger" />
			<div className="text-sm font-medium text-text-primary">{title}</div>
			<div className="max-w-md text-xs text-text-muted">{reason}</div>
			{onRetry ? (
				<div className="pt-2">
					<Button type="button" variant="outline" size="sm" disabled={retrying} onClick={onRetry}>
						{retrying ? "重试中…" : "重试"}
					</Button>
				</div>
			) : null}
		</div>
	);
}
